import { useEffect, useState } from "react";
import styles from "./styles/style.module.scss";
import TrainingSessionDetails from "./components/trainingSessionDetails";
import Footer from "../footer";

import { useParams } from "react-router-dom";
import { functionService } from "../../lib/functions";



const initalTrainingData = {
  title: "",
  duration: null,
  durationType: "week",
  contentLink: "",
  maximumSeats: null,
  availableSeats: null,
  registrationLink: "",
  description: "",
  img: "",
  emails: [],
};
const AddTraining = ({ type }) => {

  const [trainingData, setTrainingData] = useState(initalTrainingData);

  let { id } = useParams();

  const getCurrentTrainingDetails = async ({ currentTrainingId }) => {
    let { response } = await functionService.get(
      `rocketSeries/${currentTrainingId}`
    );
    if (response) {
      const latestTrainingData = {
        ...response?.data?.data[0],
        img: response?.data?.data[0]?.imageLink
      };

      setTrainingData(latestTrainingData);
    }
  };

  useEffect(() => {
    if (id) {
      getCurrentTrainingDetails({
        currentTrainingId: id,
      });
    }
  }, [id]);

  return (
    <>
      <div
        style={{ height: "100vh", overflow: "scroll" }}
        className={styles.training}
      >
        <div className={styles.scheduleHeading}>
          {type === "EDIT" ? "Edit Rocket Series" : "Create Rocket Series"}
        </div>
        <div className={styles.sessionsBox}>
          <TrainingSessionDetails
            type={type}
            setTrainingData={setTrainingData}
            trainingData={trainingData}
          />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AddTraining;
